module.exports = __webpack_public_path__ + "images/icon/import_collection-f02e239f.svg";